import React from 'react';
import { Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';

function NavigationPrev({ innerProps }) {
  return (
    <Button
      className="file-viewer__navigation-btn file-viewer__navigation-btn--prev"
      {...innerProps}
      icon={<RightOutlined width={12} height={18} />}
    />
  );
}

export default NavigationPrev;
